import { Component } from '@angular/core';
import { DestroyService } from '../../../services/destroy/destroy.service';
import { SubscriptionModel, SubscriptionServiceProxy } from '../../../../shared/service-proxies/event-service-proxy';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs';

@Component({
    selector: 'app-account-page',
    templateUrl: './account-page.component.html',
    styleUrl: './account-page.component.scss',
    standalone: false,
    providers: [DestroyService],
})
export class AccountPageComponent { 

    private accountId: string = '';
    private subscription: SubscriptionModel = new SubscriptionModel();

    constructor(private _subscriptionService: SubscriptionServiceProxy, private route: ActivatedRoute, private destroyService: DestroyService) {
        this.accountId = this.route.snapshot.params.id;
    }

    getSubscription() {
        this._subscriptionService.getSubscription(this.accountId)
            .pipe(takeUntil(this.destroyService.onDestroy$))
            .subscribe(subscription => {
                this.subscription = subscription;
            })
    }

}
